module.exports = __webpack_public_path__ + "img/n-h-page2-1.f8ce6704.png";